var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Rect, Defs, ClipPath } from "react-native-svg";
var SvgConfigurationDouble = function SvgConfigurationDouble(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 125,
    height: 70,
    viewBox: "0 0 125 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_2948_17148)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.278 8.425A34.863 34.863 0 0 0 35.5 0C16.17 0 .5 15.67.5 35s15.67 35 35 35a34.863 34.863 0 0 0 22.778-8.425A40.838 40.838 0 0 1 48.5 35a40.838 40.838 0 0 1 9.778-26.575ZM62.5 57.273A34.857 34.857 0 0 0 70.5 35a34.857 34.857 0 0 0-8-22.273A34.857 34.857 0 0 0 54.5 35a34.857 34.857 0 0 0 8 22.273Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.307 23.9a1.575 1.575 0 0 0-.48-.075h-4.8V22.2c0-.884-.729-1.6-1.613-1.6a1.61 1.61 0 0 0-1.612 1.6v6.4c0 .883.729 1.6 1.612 1.6.884 0 1.613-.717 1.613-1.6v-1.624h4.61c.184-1.04.408-2.065.67-3.076Zm-1.3 9.524H36.002a1.575 1.575 0 1 0 0 3.15h12.065a41.618 41.618 0 0 1-.06-3.15Zm.944 9.606a1.63 1.63 0 0 0-.124-.005h-11.25v-1.65a1.575 1.575 0 0 0-3.15 0v6.45a1.575 1.575 0 1 0 3.15 0v-1.65h11.25c.321 0 .62-.095.868-.26-.282-.947-.53-1.91-.744-2.885ZM21.601 25.4c0-.87.706-1.574 1.576-1.574H36a1.575 1.575 0 0 1 0 3.15H23.177c-.87 0-1.575-.705-1.575-1.575Zm6.375 6.4c0-.884.73-1.6 1.613-1.6s1.613.716 1.613 1.6v6.4c0 .883-.73 1.6-1.613 1.6a1.611 1.611 0 0 1-1.613-1.6v-1.626h-4.8a1.575 1.575 0 0 1 0-3.15h4.8V31.8Zm-4.8 11.226a1.575 1.575 0 0 0 0 3.15h6.45a1.575 1.575 0 0 0 0-3.15h-6.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M124.5 35c0 19.33-15.67 35-35 35s-35-15.67-35-35 15.67-35 35-35 35 15.67 35 35Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7 23.8v-3.2a1.6 1.6 0 1 1 3.2 0v3.2h1.6a3.2 3.2 0 0 1 3.199 3.2v1.6h3.201a1.6 1.6 0 1 1 0 3.2h-3.201v6.4h3.201a1.6 1.6 0 1 1 0 3.2h-3.201V43a3.2 3.2 0 0 1-3.2 3.2H95.9v3.2a1.6 1.6 0 1 1-3.2 0v-3.2h-6.4v3.2a1.6 1.6 0 1 1-3.2 0v-3.2h-1.6a3.2 3.2 0 0 1-3.2-3.2v-1.6h-3.2a1.6 1.6 0 1 1 0-3.2h3.2v-6.4h-3.2a1.6 1.6 0 1 1 0-3.2h3.2V27a3.2 3.2 0 0 1 3.2-3.2h1.6v-3.2a1.6 1.6 0 1 1 3.2 0v3.2h6.4Zm1.6 17.6h.004a1.6 1.6 0 0 0 1.595-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-9.6a1.6 1.6 0 0 0-1.6 1.65v9.5l.001.05V39.836a1.6 1.6 0 0 0 1.6 1.564h9.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 86.301,
    y: 31.8,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_2948_17148"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(.5)",
    d: "M0 0h124v70H0z"
  })))));
};
export default SvgConfigurationDouble;